import { useEffect, useState } from "react";
import TimeoutedUser from "./TimeoutedUser";
import { sendMessage, listenToMessages } from "../../wsFunctions/socket";

function Tab2helperView(props) {
    // Form values
    const [userIDSelected, setUserIDSelected] = useState("none");
    const [number, setNumber] = useState("");
    const ids = props.ids;
    // Få alle timeout users
    const [users, setUsers] = useState([]);
    //Oppdater hver gang vi får melding om nye
    useEffect(() => {
        const listner = listenToMessages((e) => {
            if (e.data.type === "timeout-users-updated") {
                setUsers(e.data.data.users);
            };
        });

        sendMessage({type: "tab-2-opened", data: ''})
        return () => {listner()};
    }, [])
    

    //Functions
    const timeoutUser = () => {
        sendMessage({type: "timeout-users-add", data: {userID: userIDSelected, timestamp: (Date.now() + number*60*1000)}});
        setNumber("");
        setUserIDSelected("none");
    };

    const changeCooldown = (id, newTime) => {
        sendMessage({type: "timeout-users-change", data: {userID: id, timestamp: (Date.now() + newTime*60*1000)}});
    };



    return (
        <div>
            <div className="user-timeout-form">
                <select value={userIDSelected} onChange={(e) => { setUserIDSelected(e.target.value) }}>
                    <p>Bruker ID-er (viser kun de som har en pågående forespørsel)</p>
                    <option value="none" disabled hidden>Velg brukerID</option>
                    {ids.map((id, i) => {
                        if (users.some(user => user.userID === id)) {
                            return '';
                        };
                        return (<option key={i} value={id}>{id}</option>)
                    })}
                </select>
                <input value={number} onChange={(e) => { setNumber(e.target.value) }} placeholder="Minutter" type="number" inputMode="numeric" />
                <button onClick={timeoutUser} className="change-btn">Timeout bruker</button>
            </div>
            <div className="deactivated-list">
                {users.map((user, i) => (
                    <TimeoutedUser
                        key={i}
                        user={user}
                        changeCooldown={changeCooldown}
                    />
                ))}
            </div>
        </div>
    );
};

export default Tab2helperView;